import { createStore } from "redux";
import rootreduser from "./redusers/index";
const store =createStore(rootreduser,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export default store;